export default "__VITE_ASSET__CIz2FArN__"